import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  TextField,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import {OTHER_LIVE_URL} from "../../../Configurations/Urls"
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";
import { formatDate, formatTime } from "../../../Utils/DateAndTime";

function InternTaskTimeLogForm({ mode: modeProp }) {

  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  const mode = modeProp ?? (id ? "edit" : "add");

  const { userData, reporting_manager_interns } = useAuthStore();
  const org = userData?.organization;
  const loginUserOrgPersonId = userData?.loginuser?.[0]?.organization_person_id;

  const fetchProjectTasksScheduleTimelogs = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/project-task-schedule-timelog/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;

      console.log("task schedule timelog data is : ", data);
      console.log("taskSchedule:", data?.taskSchedule);
      console.log("task_schedule:", data?.task_schedule);

      if (data) {
        // Handle both camelCase (taskSchedule) and snake_case (task_schedule) from Laravel JSON
        const taskSchedule = data.taskSchedule || data.task_schedule;
        const task = taskSchedule?.task;
        
        console.log("Extracted taskSchedule:", taskSchedule);
        console.log("Extracted task:", task);
        
        // Get task_id from nested task or directly from schedule as fallback
        const taskId = task?.organization_project_task_id || taskSchedule?.organization_project_task_id || "";
        
        setFormattedEmployeeName(data.formatted_employee || "");
        setFormData({
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          organization_project_task_id: taskId,
          organization_project_task_schedule_id: data.organization_project_task_schedule_id || "",
          organization_person_id: data.organization_person_id || "",
          organization_project_task_type_id: data.organization_project_task_type_id || "",
          log_date: formatDate(data.log_date) || "",
          start_time: formatTime(data.start_time) || "",
          end_time: formatTime(data.end_time) || "",
          total_minutes: data.total_minutes || "",
          remarks: data.remarks || ""
        });
      }
    } catch (error) {
      toast.error("Failed to fetch Task TimeLog.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if ((mode === "edit" || mode === "view") && id) {
      fetchProjectTasksScheduleTimelogs();
    }
  }, [mode, id]);

  const [formattedEmployeeName, setFormattedEmployeeName] = useState("");

  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    organization_project_task_id: "",
    organization_project_task_schedule_id: "",
    organization_person_id: "",
    organization_project_task_type_id: "",
    log_date: "",
    start_time: "",
    end_time: "",
    total_minutes: ""
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {
    const errors = {};

    if (!formData.organization_project_task_id) {
      errors.organization_project_task_id = "Task is required";
    }

    if (!formData.organization_project_task_schedule_id) {
      errors.organization_project_task_schedule_id = "Task Schedule is required";
    }

    if (!formData.organization_person_id) {
      errors.organization_person_id = "Employee/Intern is required";
    }

    if (!formData.log_date) {
      errors.log_date = "Log date is required";
    }

    // Time difference check
    if (formData.start_time && formData.end_time && formData.total_minutes) {
      const [startHour, startMinute] = formData.start_time.split(":").map(Number);
      const [endHour, endMinute] = formData.end_time.split(":").map(Number);

      const start = new Date();
      start.setHours(startHour, startMinute, 0);

      const end = new Date();
      end.setHours(endHour, endMinute, 0);

      const diffInMs = end - start;
      const diffInMinutes = Math.floor(diffInMs / 60000); // ms to minutes

      if (diffInMinutes < 0) {
        errors.end_time = "End time must be after start time";
      } else if (diffInMinutes !== Number(formData.total_minutes)) {
        errors.total_minutes = `Total minutes should be ${diffInMinutes}`;
      }
    }

    // validatr ethe form 

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const [selectOptions, setSelectOptions] = useState({
    Tasks: [],
    Schedules: [],
    Employees: [],
    TaskTypes: []
  })



  useEffect(() => {


    const fetchScheduleList = async () => {
      try {
        const response = await axios.get(`${MAIN_URL}/api/project-management/project-task-schedule`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params: {
            per_page: "all",
            organization_id: org?.organization_id,
            mode: 3,
            organization_project_task_id: formData.organization_project_task_id
          },
        });

        setSelectOptions((prev) => ({ ...prev, Schedules: response.data.data }));

      } catch (e) {
        console.error("Failed to load project task type");
      }
    };


    if (formData.organization_project_task_id) {
      fetchScheduleList()
    }
  }, [formData.organization_project_task_id])

  const fetchEmployeesOfOrg = async () => {
    try {
      const response = await axios.get(`${OTHER_LIVE_URL}/api/organizations/${org.organization_id}/persons-data-all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
       
      });

      // Filter only interns (person_type_id = 2) - show all org interns for reporting managers
      let allPersons = (response.data.persons || []).filter(
        (person) => person.organization_person?.person_type_id === 2
      );
      const sortedEmps = [...allPersons].sort((a, b) =>
        (`${a.first_name} ${a.last_name} - ${a.organization_person?.person_code}` || "").localeCompare(`${b.first_name} ${b.last_name} - ${b.organization_person?.person_code}` || "")
      );
      setSelectOptions((prev) => ({ ...prev, Employees: sortedEmps }));
    } catch (e) {
      console.error("Failed to load Employees");
    }
  };

  const fetchTasks = async () => {
    try {
      // Fetch all tasks (no filtering)
      const taskResponse = await axios.get(`${MAIN_URL}/api/project-management/project-tasks`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      const sortedTasks = [...(taskResponse.data.data || [])].sort((a, b) =>
        (a.task_title || "").localeCompare(b.task_title || "")
      );

      setSelectOptions((prev) => ({ ...prev, Tasks: sortedTasks }));

    } catch (e) {
      console.error("Failed to load Task TimeLogs");
    }
  };

  const fetchTaskTypes = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-task-type`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      setSelectOptions((prev) => ({ ...prev, TaskTypes: response.data.data }));

    } catch (e) {
      console.error("Failed to load project task type");
    }
  };

  useEffect(() => {
    if (org?.organization_id) {
      fetchTasks()
      fetchEmployeesOfOrg();
      fetchTaskTypes();
    }
  }, [org?.organization_id]);


  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
      entities?.organization_entity_id || null;
    console.log("organization_entity_id is : ", organization_entity_id);


    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");

      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/project-task-schedule-timelog/${id}`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Task TimeLogs updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/project-task-schedule-timelog`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Task TimeLogs added");
      }

      navigate("/project-task-schedule-timelog");
    } catch (err) {
      if (err.response?.status === 422) {
        toast.error("Please fix the validation errors.");
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };


  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const viewModeEmployeeName = React.useMemo(() => {
    if (formattedEmployeeName) return formattedEmployeeName;
    const idVal = formData.organization_person_id;
    if (!idVal) return "—";
    const emp = selectOptions?.Employees?.find(
      (e) => (e.organization_person_id || e.organization_person?.organization_person_id) == idVal
    );
    if (!emp) return "—";
    const personType = emp.organization_person?.person_type_id === 1 ? "Employee" : emp.organization_person?.person_type_id === 2 ? "Intern" : "";
    return `${emp.first_name || ""} ${emp.last_name || ""} : ${emp.organization_person?.person_code || ""}${personType ? ` (${personType})` : ""}`.trim();
  }, [formattedEmployeeName, formData.organization_person_id, selectOptions?.Employees]);

  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Intern Task Schedule TimeLogs"}
        addMessage={"Intern Task Schedule TimeLogs"}
        homeLink={"/project-task-schedule-timelog/interns"}
        homeText={"Intern Task Schedule TimeLogs"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

                <TextField
                  fullWidth
                  select
                  disabled={mode === "view"}
                  label="Task *"
                  name="organization_project_task_id"
                  value={formData.organization_project_task_id}
                  onChange={handleChange}
                  error={!!formErrors.organization_project_task_id}
                  helperText={formErrors.organization_project_task_id}
                >
                  {selectOptions?.Tasks?.map((task) => (
                    <MenuItem key={task.organization_project_task_id} value={task.organization_project_task_id}>
                      {task.task_title}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  fullWidth
                  select
                  disabled={mode === "view"}
                  label="Task Schedule *"
                  name="organization_project_task_schedule_id"
                  value={formData.organization_project_task_schedule_id}
                  onChange={handleChange}
                  error={!!formErrors.organization_project_task_schedule_id}
                  helperText={formErrors.organization_project_task_schedule_id}
                >
                  {selectOptions?.Schedules?.map((task) => (
                    <MenuItem key={task.organization_project_task_schedule_id} value={task.organization_project_task_schedule_id}>
                      {task.scheduled_date} ({task.allocated_hours_format})
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  fullWidth
                  select
                  disabled={mode === "view"}
                  label="Task Type"
                  name="organization_project_task_type_id"
                  value={formData.organization_project_task_type_id}
                  onChange={handleChange}
                  error={!!formErrors.organization_project_task_type_id}
                  helperText={formErrors.organization_project_task_type_id}
                >
                  {selectOptions?.TaskTypes?.map((task) => (
                    <MenuItem key={task.organization_project_task_type_id} value={task.organization_project_task_type_id}>
                      {task.task_type_name}
                    </MenuItem>
                  ))}
                </TextField>

                {mode === "view" ? (
                  <TextField
                    fullWidth
                    disabled
                    label="Employee/Intern *"
                    value={viewModeEmployeeName}
                  />
                ) : (
                  <TextField
                    fullWidth
                    select
                    label="Employee/Intern *"
                    name="organization_person_id"
                    value={formData.organization_person_id ?? ""}
                    onChange={handleChange}
                    error={!!formErrors.organization_person_id}
                    helperText={formErrors.organization_person_id}
                    SelectProps={{
                      renderValue: (val) => {
                        if (!val) return "";
                        const emp = selectOptions?.Employees?.find(
                          (e) => (e.organization_person_id || e.organization_person?.organization_person_id) == val
                        );
                        if (emp) {
                          const personType = emp.organization_person?.person_type_id === 1 ? "Employee" : emp.organization_person?.person_type_id === 2 ? "Intern" : "";
                          return `${emp.first_name || ""} ${emp.last_name || ""} : ${emp.organization_person?.person_code || ""}${personType ? ` (${personType})` : ""}`.trim();
                        }
                        if (formattedEmployeeName) return formattedEmployeeName;
                        return val;
                      },
                    }}
                  >
                    {selectOptions?.Employees?.map((emp) => {
                      const personId = emp.organization_person_id || emp.organization_person?.organization_person_id;
                      const personType = emp.organization_person?.person_type_id === 1 ? 'Employee' : 
                                       emp.organization_person?.person_type_id === 2 ? 'Intern' : '';
                      return (
                        <MenuItem key={personId} value={personId}>
                          {`${emp.first_name} ${emp.last_name} : ${emp.organization_person?.person_code}${personType ? ` (${personType})` : ''}`}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                )}

                <TextField
                  fullWidth
                  disabled={mode === "view"}
                  label={`Log Date`}
                  name="log_date"
                  type="date"

                  InputLabelProps={{ shrink: true }}
                  value={formData.log_date}
                  onChange={handleChange}
                  error={!!formErrors.log_date}
                  helperText={formErrors.log_date}
                />

                <TextField
                  fullWidth
                  disabled={mode === "view"}
                  label={`Start Time`}
                  name={`start_time`}
                  type="time"
                  InputLabelProps={{ shrink: true }}
                  value={formData.start_time}
                  onChange={handleChange}
                  error={!!formErrors.start_time}
                  helperText={formErrors.start_time}
                />

                <TextField
                  fullWidth
                  disabled={mode === "view"}
                  label={`End Time`}
                  name={`end_time`}
                  type="time"
                  InputLabelProps={{ shrink: true }}
                  value={formData.end_time}
                  onChange={handleChange}
                  error={!!formErrors.end_time}
                  helperText={formErrors.end_time}
                />

                <TextField
                  fullWidth
                  disabled={mode === "view"}
                  label="Total Minutes"
                  name="total_minutes"
                  type="number"
                  value={formData.total_minutes}
                  onChange={handleChange}
                  error={!!formErrors.total_minutes}
                  helperText={formErrors.total_minutes}
                />

                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  disabled={mode === "view"}
                  label="Remarks"
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                  error={!!formErrors.remarks}
                  helperText={formErrors.remarks}
                />

              </Grid>
              {mode !== "view" && (
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>
              )}

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default InternTaskTimeLogForm